import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { MaterialAlertIconClass } from '../material-alert/material-alert.enum';

@Component({
    selector: 'ecm-mat-snack-bar',
    templateUrl: './material-snack-bar.component.html',
})
export class MaterialSnackBarComponent {
    @Input() public style: MaterialAlertIconClass;

    @Input() public text: string;

    @Input() public linkAttributes?: { label: string; url: string };

    @Output() public materialSnackBarEvent: EventEmitter<any> = new EventEmitter<any>();

    public show = false;

    private displayDelay = 6000;

    private launchTime: number;

    private timer: number;

    /**
     * reset snackbar and launch animation
     * *** usage ***
     * use snackBar component as @ViewChild in parent component to call launch method
     */
    public launch(): void {
        this.displayDelay = 6000;
        if (this.timer) {
            this.show = false;
            clearTimeout(this.timer);
            setTimeout(() => {
                this.show = true;
                this.startAnimation();
            }, 200);
        } else {
            this.show = true;
            this.startAnimation();
        }
    }

    /**
     * Emit event on snackBar link
     */
    public materialSnackBarLink(): void {
        this.materialSnackBarEvent.emit();
    }

    @HostListener('mouseenter')
    @HostListener('focus')
    private pausedAnimation(): void {
        const stoppedTime = new Date().getTime();
        clearTimeout(this.timer);
        const passedTime = stoppedTime - this.launchTime;
        if (passedTime <= this.displayDelay) {
            this.displayDelay = this.displayDelay - passedTime;
        }
    }

    @HostListener('mouseleave')
    @HostListener('blur')
    private startAnimation() {
        this.launchTime = new Date().getTime();
        this.timer = setTimeout(() => (this.show = false), this.displayDelay) as unknown as number;
    }
}
